import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

import { Subhead } from '../Typography';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 40px 0 60px;

  @media ${breakpoint.md} {
    padding: 80px 0 120px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: var(--executive-website-heading-font-family);
  margin-block: 0.5rem;
  text-align: center;
`;

export const Subheader = styled.p`
  ${Subhead};
  width: 100%;
  margin-top: 0;
  color: ${({ theme: { colors } }) => colors.primaryBlue[900]};
  text-align: center;

  @media ${breakpoint.sm} {
    font-weight: ${({ theme }) => theme.fontWeight.semiMedium};
  }
`;
